module.exports = __webpack_public_path__ + "img/png_image.78be01a3.png";